import React, { useState, useRef, useEffect } from 'react';
import { Flex, Box, css } from 'theme-ui';
import Reveal from '@solid-ui-components/Reveal';
import Divider from '@solid-ui-components/Divider';
import ContentText from '@solid-ui-components/ContentText';
import ContentButtons from '@solid-ui-components/ContentButtons';
import ListItem from '@solid-ui-components/ListItem';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';

const styles = {
  collectionWrapper: {
    display: 'flex',
    overflowX: 'hidden',
    position: 'relative',
    padding: '0 10px',
    overflowY: 'hidden',
    '@media screen and (max-width: 768px)': {
      flexWrap: 'nowrap',
    },
  },
  item: {
    flex: '0 0 auto',
    marginRight: '10px',
    '@media screen and (min-width: 769px)': {
      width: 'calc(20% - 10px)',
    },
    '@media screen and (max-width: 768px)': {
      width: 'calc(33.33% - 5px)',
    },
  },
  iconProps: {
    width: '40px',
    height: '40px',
    p: 0,
  },
  iconWrapper: {
    p: '12px',
    backgroundColor: '#026AA2',
    borderRadius: '8px',
    boxShadow: '0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814',
  },
};

const FeaturesBlock09 = ({ content: { text, collection, buttons } }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (containerRef.current) {
        const scrollAmount = containerRef.current.scrollWidth / collection.length;
        containerRef.current.scrollBy({
          left: scrollAmount,
          behavior: 'smooth',
        });

        if (containerRef.current.scrollLeft + containerRef.current.offsetWidth >= containerRef.current.scrollWidth) {
          containerRef.current.scrollTo({
            left: 0,
            behavior: 'smooth',
          });
        }
      }
    }, 2000);

    return () => clearInterval(intervalId);
  }, [collection.length]);

  useEffect(() => {
    const handleScroll = () => {
      const container = containerRef.current;
      if (!container) return;

      const scrollLeft = container.scrollLeft;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;

      if (scrollLeft >= maxScrollLeft - 5) {
        const delay = window.innerWidth <= 768 ? 200 : 500;
        
        setTimeout(() => {
          container.scrollTo({
            left: 0,
            behavior: 'smooth',
          });
        }, delay);
      }
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [collection.length]);

  return (
    <Box as={Reveal} sx={{ position: 'relative' }}>
      <Box sx={{ textAlign: 'center' }}>
        <ContentText content={text} />
      </Box>
      {collection && (
        <Flex
          sx={styles.collectionWrapper}
          ref={containerRef}
        >
          {collection.map((props, index) => (
            <Reveal
              key={`item-${index}`}
              effect="fadeInGrow"
              css={css(styles.item)}
            >
              <ListItem
                {...props}
                iconProps={styles.iconProps}
                vertical
                center
                size="m"
                iconStyles={styles.iconWrapper}
                wrapperStyles={{ gap: 4 }}
              />
            </Reveal>
          ))}
        </Flex>
      )}
    </Box>
  );
};

export default WithDefaultContent(FeaturesBlock09);
